import { ModalProductToAdd as RegularModal } from 'src/components/restructure/product/ProductCard/ModalProductToAdd/ModalProductToAdd'
import { MiniPdp } from 'src/components/restructure/product/ProductCard/ModalProductToAdd/MiniPdp'
import { MINI_PDP_EXPERIMENT_ID } from 'src/components/common/StatsigExposure/StatsigExposure'
import { Statsig } from 'src/sdk/statsig'

export type { ModalProductToAddProps } from './ModalProductToAdd'

type ModalProductToAddProps = React.ComponentProps<typeof RegularModal>

export const ModalProductToAdd = (props: ModalProductToAddProps) => {
  const isMiniPdpExperimentEnabled = Statsig.useStatsigFeatureGateValue(
    MINI_PDP_EXPERIMENT_ID
  )

  if (isMiniPdpExperimentEnabled) {
    return <MiniPdp {...props} />
  }

  return <RegularModal {...props} />
}
